var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHexagonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5871_43206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1 16.9999H21.3213L19.5107 18.8476L20.5 19.8571L24 16.2857L20.5 12.7142L19.5107 13.7238L21.3213 15.5714H12.1V16.9999Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5547 18.3048L11.6053 20.0096L4.81067 16.0858V7.91435L11.6053 3.99054L18.4 7.91435V12.0001H20.2107V7.37149C20.2107 7.03816 20.0333 6.73339 19.7533 6.57149L12.0533 2.12387C11.7733 1.96197 11.4373 1.96197 11.1573 2.12387L3.45733 6.58101C3.17733 6.74292 3 7.04768 3 7.38101V16.6286C3 16.962 3.17733 17.2667 3.45733 17.4286L11.1573 21.8762C11.2973 21.962 11.4467 22.0001 11.6053 22.0001C11.764 21.9905 11.9133 21.9429 12.0533 21.8667L14.5547 20.4191V18.3048Z",
    fill: "#030712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5871_43206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHexagonArrow);
export default __webpack_public_path__ + "static/media/ic-hexagon-arrow.c8aa44464a5f48b5524f5f886fa41d69.svg";
export { ForwardRef as ReactComponent };